import * as Yup from "yup";

const firstSchema = Yup.object().shape({
  cpfCnpj: Yup.string().required("*O CPF é obrigatório"),
});

export default firstSchema;
